import { render } from "./appHeader.vue?vue&type=template&id=27631224&scoped=true&ts=true"
import script from "./appHeader.vue?vue&type=script&lang=ts"
export * from "./appHeader.vue?vue&type=script&lang=ts"

import "./appHeader.vue?vue&type=style&index=0&id=27631224&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27631224"]])

export default __exports__